// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2nqQb","head":"Table_head__18Cxz","col":"Table_col__3iHro"};